import React from "react";
import useToggle from "../../../hooks/useToggle";
import GoToTop from "../../Helpers/GoToTop";
import CheckoutModal from "../../Helpers/Modals/CheckoutModal";
import Drawer from "../../Mobile/Drawer";
import FooterOne from "../../Partials/Footers/FooterOne";
import HeaderOne from "../../Partials/Headers/HeaderOne";
import MainContent from "../PlaceABidCom/MainContent";

function PlaceBidThree() {
  const [drawer, setDrawer] = useToggle(false);
  const [value, setValue] = useToggle(true);
  return (
    <>
      <Drawer drawer={drawer} action={setDrawer.toggle} />
      <HeaderOne className="shop-page-header" action={setDrawer.toggle} />
      <MainContent modalAction={setValue.toggle}>
        <CheckoutModal
          action={setValue.toggle}
          value={value}
          className=" modal-area2 product-details-popup place-bid3"
        />
      </MainContent>
      <FooterOne />
      <GoToTop />
    </>
  );
}

export default PlaceBidThree;
